export default function sortBy(arr, by) {
  return arr.sort(compare);

  function compare(a, b) {
    let result = 0;

    if (!Array.isArray(by)) by = [by];

    by.forEach(function(x) {
      if (result !== 0) return;

      const rootKey = x.key ?? x;
      const pathKeys = rootKey.split(".");

      let testA, testB;

      pathKeys.forEach(function(key) {
        testA = testA ? testA[key] : a[key];
        testB = testB ? testB[key] : b[key];
      });

      if (testA < testB) {
        result = x.direction === "asc" ? 1 : -1;
      }
      if (testA > testB) {
        result = x.direction === "asc" ? -1 : 1;
      }
    });

    return result;
  }
}
